// extracted by mini-css-extract-plugin
export var compactFilters = "_dk-4";
export var detailImage = "_dk-1";
export var dropdownContainer = "_dk-2";
export var imageContainer = "_dk-0";
export var selectedCard = "_dk-3";